'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import Input from '@/components/elements/Input'
import { Button } from '@/components/elements/Button'
import { navigateUrl } from '@/utils/client-request'
import { useLoginForm } from '@/lib/commerce/hooks'
import { formatImageURL } from '@/utils/util'

export default function Login({ vendor }: { vendor?: any }) {
  const pathname = usePathname()
  const f = useLoginForm({ defaultRedirect: '/', refreshAfter: true, clearErrorParam: true })

  return (
    <div className="w-full max-w-md">
      <div className="flex flex-col items-center gap-6">
        {vendor?.logo ? (
          <img src={formatImageURL(vendor?.logo)} alt="logo" className="h-8 max-w-40 w-auto object-contain" />
        ) : vendor?.name ? (
          <div className="text-xl sm:text-2xl font-bold tracking-tight">{vendor?.name}</div>
        ) : null}
        <h1 className="text-center text-foreground text-3xl font-semibold leading-7.5 tracking-[-0.7%]">Нэвтрэх</h1>
      </div>
      <div className="mt-14">
        <div className="flex flex-col gap-4">
          <form onSubmit={f.handleLogin} className="flex flex-col gap-y-4">
            <Input label="Утасны дугаар / Имэйл" type="text" placeholder="Утасны дугаар эсвэл имэйл хаяг" value={f.emailOrPhone} onChange={(e: any) => f.setEmailOrPhone(e.target.value)} onKeyDown={f.handleKeyDown} autoFocus />
            <div>
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium leading-none">Нууц үг</span>
                <Link href={navigateUrl(`/forgot`, pathname)} className="text-sm font-medium text-foreground hover:text-foreground/90 transition">
                  Нууц үгээ мартсан уу?
                </Link>
              </div>
              <Input type="password" placeholder="Таны нэвтрэх нууц үг" value={f.password} onChange={(e: any) => f.setPassword(e.target.value)} onKeyDown={f.handleKeyDown} />
            </div>
            <Button type="submit" isLoading={f.loading} variant="outline" className="mt-2 w-full h-10 bg-foreground text-white font-medium! border-foreground hover:bg-foreground/90 hover:text-white transition-all" loadingMessage="Нэвтэрч байна...">
              Нэвтрэх
            </Button>
          </form>
          <div className="flex items-center justify-center gap-2">
            <div className="grow basis-0 border-b border-neutral-200" />
            <span className="text-sm font-medium leading-5 tracking-[-0.5%] text-muted-foreground">Эсвэл</span>
            <div className="grow basis-0 border-b border-neutral-200" />
          </div>
        </div>
      </div>
      <p className="mt-4 text-center text-foreground leading-5">
        Шинэ хэрэглэгч үү?{' '}
        <span onClick={f.routeToRegister} className="cursor-pointer font-medium text-foreground underline hover:text-foreground/90 leading-5 tracking-[-0.5%] transition-colors">
          Бүртгэл үүсгэх
        </span>
      </p>
      <div className="mt-12 w-full">
        <a className="relative block overflow-hidden rounded-md border border-zinc-300 bg-zinc-100 px-8 py-4 transition-colors hover:bg-zinc-50" href="https://app.shop.mn" target="_blank" rel="noopener noreferrer">
          <div className="absolute inset-y-0 left-1/2 w-160 -translate-x-1/2" role="presentation">
            <svg className="pointer-events-none absolute inset-0 text-neutral-200" width="100%" height="100%">
              <defs>
                <pattern id="dots-login" x="0" y="4" width="12" height="12" patternUnits="userSpaceOnUse">
                  <rect x="1" y="1" width="2" height="2" fill="currentColor" />
                </pattern>
              </defs>
              <rect fill="url(#dots-login)" width="100%" height="100%" />
            </svg>
          </div>
          <div className="relative text-center text-foreground leading-5 tracking-[-0.5%]">
            Хэрэв та дэлгүүрийн ажилтан бол <span className="font-semibold text-foreground">app.shop.mn</span> хаягаар нэвтэрнэ үү
          </div>
        </a>
      </div>
    </div>
  )
}
